import type { Step } from 'react-joyride';
import type { BeaconStepData, TourDefinition } from '../types';
import { talentPoolScoredTour } from './talentPoolScoredTour';
import { firstCriteriaGeneratedTour } from './firstCriteriaGeneratedTour';

export const tourRegistry: Record<string, TourDefinition> = {
  [firstCriteriaGeneratedTour.id]: firstCriteriaGeneratedTour,
  [talentPoolScoredTour.id]: talentPoolScoredTour,
};

export { FIRST_CRITERIA_GENERATED_TOUR_ID } from './firstCriteriaGeneratedTour';
export { FIRST_TALENT_POOL_TOUR_ID } from './talentPoolScoredTour';

export function buildJoyrideSteps(def: TourDefinition): Step[] {
  const spotlightSteps = def.steps.filter((s) => s.kind !== 'modal');
  const stepTotal = spotlightSteps.length;

  return def.steps.map((step) => {
    const isModal = step.kind === 'modal';
    const advance = step.advance ?? 'next';
    const targetSelector = step.target ? `[data-tour="${step.target}"]` : undefined;

    const data: BeaconStepData = {
      kind: isModal ? 'modal' : 'spotlight',
      eyebrow: step.eyebrow,
      advance,
      waitHint: step.waitHint,
      primaryLabel: step.primaryLabel,
      skipLabel: step.skipLabel,
      route: step.route,
      targetSelector,
      stepNumber: isModal ? undefined : spotlightSteps.indexOf(step) + 1,
      stepTotal: isModal ? undefined : stepTotal,
    };

    return {
      target: targetSelector ?? 'body',
      title: step.title,
      content: step.body,
      placement: isModal ? 'center' : (step.placement ?? 'bottom'),
      blockTargetInteraction: advance !== 'click',
      disableFocusTrap: !isModal,
      ...(step.scrollOffset != null ? { scrollOffset: step.scrollOffset } : {}),
      data,
    } satisfies Step;
  });
}
